// generated by python script:
export const WORDS = [
  'SZS|-⟩=|-⟩',
  'SSH|0⟩=|-⟩',
  'IHX|+⟩=|0⟩',
  'ZZH|1⟩=|-⟩',
  'XIS|0⟩=|1⟩',
  'XHI|+⟩=|1⟩',
  'SXY|1⟩=|1⟩',
  'ZZH|+⟩=|0⟩',
  'IZS|0⟩=|0⟩',
  'XX|0⟩=Z|0⟩',
  '|1⟩=ZSY|0⟩',
  'Z|-⟩=SS|-⟩',
  'XSZ|0⟩=|1⟩',
  'S|0⟩=TS|0⟩',
  'SZ|-⟩=S|+⟩',
  'IZZ|0⟩=|0⟩',
  'TT|i-⟩=|+⟩',
  'IIH|-⟩=|1⟩',
  'HSI|0⟩=|+⟩',
  '|+⟩=SI|i-⟩',
  'I|0⟩=HI|+⟩',
  'HXI|+⟩=|0⟩',
  '|-⟩=HHZ|+⟩',
  'XIX|-⟩=|-⟩',
  'SZ|-⟩=|i+⟩',
  '|0⟩=YSX|0⟩',
  '|i-⟩=SH|1⟩',
  '|+⟩=HII|0⟩',
  'S|-⟩=TT|-⟩',
  '|1⟩=XTH|+⟩',
  'I|0⟩=TT|0⟩',
  'HHS|0⟩=|0⟩',
  'Z|0⟩=ZZ|0⟩',
  'HX|0⟩=I|-⟩',
  'ISS|+⟩=|-⟩',
  'ZYY|0⟩=|0⟩',
  '-|+⟩=ZX|-⟩',
  'H|-⟩=HH|1⟩',
  '|+⟩=ZS|i+⟩',
  '|0⟩=TSS|0⟩',
  'HH|+⟩=Z|-⟩',
  'Z|0⟩=SH|+⟩',
  'SXH|-⟩=|0⟩',
  'ZX|0⟩=Z|1⟩',
  '-|1⟩=H-|-⟩',
  '|1⟩=XZH|+⟩',
  'SX|1⟩=T|0⟩',
  '|1⟩=XHI|+⟩',
  'SS|-⟩=Z|-⟩',
  'HI|0⟩=H|0⟩',
  'SZH|+⟩=|0⟩',
  'TZI|0⟩=|0⟩',
  'XX|-⟩=H|1⟩',
  'IIX|1⟩=|0⟩',
  'X|+⟩=ZI|-⟩',
  'HH|0⟩=H|+⟩',
  'IZ|0⟩=I|0⟩',
  'II|+⟩=I|+⟩',
  '|-⟩=ZIZ|-⟩',
  'Z|0⟩=SS|0⟩',
  'TXI|1⟩=|0⟩',
  'Z|-⟩=HS|0⟩',
  '|-⟩=IHX|0⟩',
  'XZ|-⟩=I|+⟩',
  'I|0⟩=IH|+⟩',
  '|1⟩=XSZ|0⟩',
  'S|0⟩=TH|+⟩',
  '|i+⟩=SI|+⟩',
  'I|0⟩=YY|0⟩',
  'HII|-⟩=|1⟩',
  '|1⟩=XXH|-⟩',
  'S|i+⟩=H|1⟩',
  '|+⟩=XSS|-⟩',
  '|1⟩=XZT|0⟩',
  'ZH|+⟩=H|+⟩',
  'X|0⟩=XT|0⟩',
  'ITI|0⟩=|0⟩',
  'II|+⟩=X|+⟩',
  'HZ|+⟩=H|-⟩',
  '|0⟩=ZHI|+⟩',
  '|-⟩=SIS|+⟩',
  '-|-⟩=H-|1⟩',
  'ZT|+⟩=T|-⟩',
  '|0⟩=ZSH|+⟩',
  'Z|+⟩=HX|0⟩',
  'SH|1⟩=S|-⟩',
  'Z|0⟩=TX|1⟩',
  'I|0⟩=SH|+⟩',
  'IY|+⟩=Y|+⟩',
  'HI|-⟩=X|0⟩',
  '|-⟩=SZS|-⟩',
  'II|0⟩=S|0⟩',
  'YH|-⟩=Y|1⟩',
  'ZS|-⟩=|i+⟩',
  '|0⟩=SIT|0⟩',
  'IH|-⟩=X|0⟩',
  '|+⟩=YYX|+⟩',
  'XT|0⟩=X|0⟩',
  'Y|-⟩=YI|-⟩',
  'X|1⟩=TT|0⟩',
  '|0⟩=ZSS|0⟩',
  'ZI|-⟩=X|+⟩',
  'X|1⟩=HX|+⟩',
  'S|i-⟩=H|0⟩',
  'HHH|-⟩=|1⟩',
  'TI|1⟩=T|1⟩',
  'ZXH|-⟩=|0⟩',
  'TI|0⟩=Z|0⟩',
  'XX|0⟩=I|0⟩',
  'II|-⟩=Z|+⟩',
  'ZHX|+⟩=|0⟩',
  'H|0⟩=HZ|0⟩',
  '|-⟩=YXY|-⟩',
  'S|0⟩=XH|-⟩',
  'IY|1⟩=Y|1⟩',
  'SZ|0⟩=Z|0⟩',
  'ZHX|0⟩=|+⟩',
  '|+⟩=ZX-|-⟩',
  'ZIX|+⟩=|-⟩',
  '|1⟩=SHY|+⟩',
  'T-|0⟩=-|0⟩',
  'ZYY|-⟩=|+⟩',
  '|1⟩=IXS|0⟩',
  'TZ|0⟩=I|0⟩',
  'X|+⟩=XZ|-⟩',
  '|0⟩=TZI|0⟩',
  'Z|+⟩=ZX|+⟩',
  'IH|1⟩=Z|+⟩',
  'I|0⟩=SX|1⟩',
  'YXY|-⟩=|-⟩',
  'SHZ|-⟩=|0⟩',
  '|+⟩=IXZ|-⟩',
  'I|-⟩=IH|1⟩',
  'TT|0⟩=T|0⟩',
  '|1⟩=SY-|0⟩',
  'S|+⟩=SZ|-⟩',
  'Y|0⟩=IY|0⟩',
  '|+⟩=ZZZ|-⟩',
  'ZZS|0⟩=|0⟩',
  'H|+⟩=II|0⟩',
  'IXS|0⟩=|1⟩',
  'Z|-⟩=XH|0⟩',
  '|0⟩=ITI|0⟩',
  'ZX|1⟩=H|+⟩',
  'YH|+⟩=Y|0⟩',
  'H|+⟩=TH|+⟩',
  'H|+⟩=TI|0⟩',
  'TSX|1⟩=|0⟩',
  'XXH|+⟩=|0⟩',
  'HH|0⟩=S|0⟩',
  '|-⟩=ZYY|+⟩',
  'SIS|+⟩=|-⟩',
  '|0⟩=SSS|0⟩',
  '|0⟩=ZTT|0⟩',
  'XH|+⟩=H|-⟩',
  'SHY|+⟩=|1⟩',
  'YTY|1⟩=|1⟩',
  'Z|+⟩=X-|-⟩',
  'IIS|0⟩=|0⟩',
  'HX-|-⟩=|1⟩',
  'XI|+⟩=H|0⟩',
  'HIX|+⟩=|0⟩',
  'ZH|0⟩=H|1⟩',
  'SH|+⟩=I|0⟩',
  'T|1⟩=TH|-⟩',
  'HH|-⟩=H|1⟩',
  'I|1⟩=YY|1⟩',
  'ZH|-⟩=Z|1⟩',
  'H|1⟩=ZX|+⟩',
  '|1⟩=HIH|1⟩',
  'YZ|0⟩=Y|0⟩',
  '|-⟩=TT|i+⟩',
  'IS|0⟩=X|1⟩',
  '|-⟩=XIX|-⟩',
  '|-⟩=XXI|-⟩',
  '|0⟩=SZX|1⟩',
  'X|1⟩=IX|1⟩',
  'S|+⟩=YS|+⟩',
  'SSZ|1⟩=|1⟩',
  '|-⟩=SY|i+⟩',
  'X|+⟩=HZ|0⟩',
  '|1⟩=HXX|-⟩',
  '|0⟩=IZT|0⟩',
  'IH|+⟩=Z|0⟩',
  '-|0⟩=S-|0⟩',
  'ZI|-⟩=I|+⟩',
  'YYH|+⟩=|0⟩',
  'H|0⟩=HI|0⟩',
  'SH|+⟩=S|0⟩',
  'I|0⟩=SZ|0⟩',
  'X|+⟩=S|i-⟩',
  'I|-⟩=HI|1⟩',
  'IX|-⟩=X|-⟩',
  'Z|0⟩=TI|0⟩',
  'H|1⟩=XX|-⟩',
  '|+⟩=XHZ|0⟩',
  'SST|0⟩=|0⟩',
  'TZH|+⟩=|0⟩',
  'HSS|-⟩=|0⟩',
  'I|+⟩=HI|0⟩',
  'IHH|1⟩=|1⟩',
  'III|-⟩=|-⟩',
  '|-⟩=XXZ|+⟩',
  'STI|0⟩=|0⟩',
  'IZ|0⟩=Z|0⟩',
  '|1⟩=ZZI|1⟩',
  'Z|-⟩=HI|0⟩',
  'HHT|0⟩=|0⟩',
  '|-⟩=HZZ|1⟩',
  'TZ|0⟩=X|1⟩',
  'Z|0⟩=ZH|+⟩',
  'X-|0⟩=-|1⟩',
  'S|i-⟩=I|+⟩',
  'TI|0⟩=T|0⟩',
  'ZZI|0⟩=|0⟩',
  '|+⟩=IZZ|+⟩',
  'XHX|+⟩=|1⟩',
  'XZ|0⟩=H|-⟩',
  '|+⟩=TTS|-⟩',
  'XZ|0⟩=X|0⟩',
  'TI|0⟩=S|0⟩',
  '|1⟩=XYS|1⟩',
  'ZZ|-⟩=H|1⟩',
  '|0⟩=XII|1⟩',
  'HH|-⟩=I|-⟩',
  '|0⟩=ZIX|1⟩',
  '-|-⟩=XI|-⟩',
  'HI|0⟩=I|+⟩',
  'HS|i-⟩=|0⟩',
  'HZZ|1⟩=|-⟩',
  '|0⟩=ZIZ|0⟩',
  'ZHI|1⟩=|+⟩',
  'YY|+⟩=Z|-⟩',
  'SHI|+⟩=|0⟩',
  'SIS|0⟩=|0⟩',
  'TH|+⟩=Z|0⟩',
  'XZ-|+⟩=|-⟩',
  'I|+⟩=YY|+⟩',
  'S|0⟩=ZZ|0⟩',
  'SH|+⟩=X|1⟩',
  'Y|0⟩=SH|-⟩',
  '-|1⟩=IZ|1⟩',
  'TIH|+⟩=|0⟩',
  'HX|+⟩=S|0⟩',
  'IH|-⟩=I|1⟩',
  'ITS|0⟩=|0⟩',
  'HXX|+⟩=|0⟩',
  'Z|i-⟩=S|+⟩',
  'XI|-⟩=X|-⟩',
  'H|+⟩=HI|+⟩',
  'IH|0⟩=Z|-⟩',
  'HXH|0⟩=|0⟩',
  'XIH|-⟩=|0⟩',
  'XS|0⟩=H|-⟩',
  '|+⟩=YIY|+⟩',
  'ZS|0⟩=Z|0⟩',
  'ZX|1⟩=S|0⟩',
  '|-⟩=IS|i+⟩',
  'HIX|0⟩=|-⟩',
  'TH|0⟩=T|+⟩',
  'HHZ|-⟩=|+⟩',
  'H|0⟩=XZ|-⟩',
  'XHZ|+⟩=|0⟩',
  '|+⟩=ZZI|+⟩',
  'ZH|+⟩=T|0⟩',
  'H|1⟩=YY|-⟩',
  'X|1⟩=SX|1⟩',
  'SYS|+⟩=|-⟩',
  'X-|+⟩=-|+⟩',
  'SY|i+⟩=|-⟩',
  'TS|0⟩=T|0⟩',
  '|i+⟩=TT|+⟩',
  '|0⟩=XXX|1⟩',
  'I|-⟩=ZZ|-⟩',
  'SH|+⟩=Z|0⟩',
  'I|-⟩=II|-⟩',
  'HZ|0⟩=H|0⟩',
  '|0⟩=STI|0⟩',
  'ZSS|-⟩=|-⟩',
  'Y|0⟩=SI|1⟩',
  'XIX|+⟩=|+⟩',
  '|1⟩=XZZ|0⟩',
  '|i+⟩=Y|i+⟩',
  'IS|1⟩=Y|0⟩',
  '|-⟩=ZS|i-⟩',
  'HZ|1⟩=-|-⟩',
  'Z|0⟩=HX|+⟩',
  'HZ|-⟩=I|0⟩',
  '|-⟩=ISS|+⟩',
  '|1⟩=XXX|0⟩',
  'I|-⟩=SS|+⟩',
  '|-⟩=IZH|0⟩',
  'Z|1⟩=X-|0⟩',
  'I|+⟩=IX|+⟩',
  'TZ|0⟩=T|0⟩',
  '|-⟩=TST|+⟩',
  '|-⟩=XI-|-⟩',
  '|+⟩=XIH|0⟩',
  '|+⟩=IS|i-⟩',
  '|0⟩=HHI|0⟩',
  '-|+⟩=X-|+⟩',
  'XT|0⟩=I|1⟩',
  'ZS|+⟩=S|-⟩',
  '|0⟩=SST|0⟩',
  '|0⟩=IIX|1⟩',
  '|i-⟩=I|i-⟩',
  'HI|1⟩=Z|+⟩',
  'S|0⟩=IZ|0⟩',
  'Z|+⟩=SS|+⟩',
  '|0⟩=XHH|1⟩',
  'H|+⟩=SI|0⟩',
  'TT|0⟩=X|1⟩',
  '|1⟩=IZZ|1⟩',
  'I|1⟩=XZ|0⟩',
  'Z|-⟩=HH|+⟩',
  'H-|0⟩=-|+⟩',
  'H|0⟩=ZH|1⟩',
  'TH|+⟩=I|0⟩',
  'S|1⟩=TT|1⟩',
  'SSZ|0⟩=|0⟩',
  'XI|1⟩=H|+⟩',
  '|0⟩=ITS|0⟩',
  'SY-|0⟩=|1⟩',
  '|+⟩=ZYY|-⟩',
  '|+⟩=III|+⟩',
  'HSH|+⟩=|+⟩',
  'IHH|+⟩=|+⟩',
  'IT|-⟩=T|-⟩',
  'HI|+⟩=X|1⟩',
  'XXI|0⟩=|0⟩',
  'S|0⟩=ZT|0⟩',
  'SSI|+⟩=|-⟩',
  'S|0⟩=II|0⟩',
  'SI|0⟩=I|0⟩',
  '|0⟩=ZHZ|-⟩',
  '|0⟩=XZZ|1⟩',
  '|0⟩=ITT|0⟩',
  '|0⟩=SIH|+⟩',
  'I|-⟩=X-|-⟩',
  'THX|+⟩=|0⟩',
  'T|0⟩=ZS|0⟩',
  'ZT|0⟩=I|0⟩',
  '|+⟩=HSH|+⟩',
  'X|+⟩=HS|0⟩',
  '|0⟩=TSZ|0⟩',
  'X|1⟩=HZ|-⟩',
  'X|0⟩=IH|-⟩',
  'XXS|0⟩=|0⟩',
  'HXS|0⟩=|-⟩',
  'HHI|1⟩=|1⟩',
  'YI|-⟩=Y|-⟩',
  'H|0⟩=ZI|-⟩',
  'I|i+⟩=S|+⟩',
  'Z|0⟩=ZX|1⟩',
  'SS|+⟩=Z|+⟩',
  '|0⟩=HIX|+⟩',
  '|1⟩=XYY|0⟩',
  'ZH|+⟩=X|1⟩',
  '|1⟩=HIZ|+⟩',
  'STZ|0⟩=|0⟩',
  'XIH|+⟩=|1⟩',
  'T|0⟩=HZ|-⟩',
  '|0⟩=ITX|1⟩',
  '|0⟩=ZIS|0⟩',
  'HZ|0⟩=I|+⟩',
  '|1⟩=IXZ|0⟩',
  'I|-⟩=S|i+⟩',
  'HHI|-⟩=|-⟩',
  'X|1⟩=ZX|1⟩',
  'IXX|-⟩=|-⟩',
  'YY|0⟩=H|+⟩',
  'T|0⟩=IT|0⟩',
  'XI|0⟩=I|1⟩',
  'II|-⟩=H|1⟩',
  'H|-⟩=IX|0⟩',
  'I|1⟩=ZZ|1⟩',
  'T|0⟩=SH|+⟩',
  'Y|1⟩=YI|1⟩',
  '-|1⟩=X-|0⟩',
  'HZH|1⟩=|0⟩',
  'SX|1⟩=I|0⟩',
  'XXZ|0⟩=|0⟩',
  'Y|+⟩=YH|0⟩',
  'SS|+⟩=I|-⟩',
  'THH|0⟩=|0⟩',
  'SZI|0⟩=|0⟩',
  '|+⟩=IZH|1⟩',
  'I|+⟩=ZI|-⟩',
  'ZX|0⟩=-|1⟩',
  '|-⟩=IHI|1⟩',
  'Z|+⟩=ZI|+⟩',
  'TZ|-⟩=T|+⟩',
  'XI|+⟩=Z|-⟩',
  'XZ|-⟩=X|+⟩',
  'X|1⟩=IZ|0⟩',
  'X|+⟩=IZ|-⟩',
  'ZZZ|+⟩=|-⟩',
  '|1⟩=XHZ|-⟩',
  'XH|-⟩=Z|0⟩',
  '|0⟩=ZZX|1⟩',
  'I|+⟩=IZ|-⟩',
  'T|1⟩=TI|1⟩',
  'I|-⟩=HX|0⟩',
  'TZ|0⟩=S|0⟩',
  'ZIZ|0⟩=|0⟩',
  'X|1⟩=HH|0⟩',
  'H|-⟩=II|1⟩',
  'I|1⟩=IH|-⟩',
  'IZ|-⟩=Z|-⟩',
  'TS|0⟩=I|0⟩',
  'XXZ|+⟩=|-⟩',
  'XHZ|-⟩=|1⟩',
  'T|0⟩=XX|0⟩',
  'XH|0⟩=I|+⟩',
  '|+⟩=ZHX|0⟩',
  'SZ|0⟩=T|0⟩',
  'S|0⟩=HX|+⟩',
  'ZZ|+⟩=X|+⟩',
  'HI|1⟩=I|-⟩',
  'S|0⟩=IT|0⟩',
  'TX|1⟩=Z|0⟩',
  'IT|0⟩=I|0⟩',
  '|-⟩=ZZH|1⟩',
  '-|1⟩=ZX|0⟩',
  'S|0⟩=HZ|-⟩',
  '|0⟩=TTX|1⟩',
  'T|-⟩=IT|-⟩',
  '|+⟩=XII|+⟩',
  'S|1⟩=YH|+⟩',
  '|0⟩=IZS|0⟩',
  'I|-⟩=ZI|+⟩',
  'ZIX|1⟩=|0⟩',
  '|+⟩=IHI|0⟩',
  '|0⟩=TZH|+⟩',
  '|0⟩=IYS|1⟩',
  'ZT|0⟩=T|0⟩',
  'SZX|1⟩=|0⟩',
  'X|0⟩=ZZ|1⟩',
  'ZZ|0⟩=X|1⟩',
  'ZTS|0⟩=|0⟩',
  '|1⟩=ZIZ|1⟩',
  'H|+⟩=ZS|0⟩',
  'Z-|+⟩=-|-⟩',
  '|-⟩=IXX|-⟩',
  'Z|0⟩=HI|+⟩',
  'ZX-|0⟩=|1⟩',
  'ZSH|+⟩=|0⟩',
  'H|-⟩=Z-|1⟩',
  'Y|+⟩=YZ|-⟩',
  'HHX|+⟩=|+⟩',
  'IX|1⟩=H|+⟩',
  'IIH|1⟩=|-⟩',
  'ZII|-⟩=|+⟩',
  'X-|1⟩=-|0⟩',
  'XIT|0⟩=|1⟩',
  'HS|0⟩=X|+⟩',
  'XZZ|0⟩=|1⟩',
  'IZ|-⟩=I|+⟩',
  'S|+⟩=SX|+⟩',
  'IZH|0⟩=|-⟩',
  'ZX|+⟩=H|1⟩',
  '|-⟩=ZHH|+⟩',
  '-|0⟩=T-|0⟩',
  'Z|0⟩=TT|0⟩',
  '|0⟩=SHZ|-⟩',
  'X|1⟩=XH|-⟩',
  'Z-|1⟩=I|1⟩',
  'Z|-⟩=XI|+⟩',
  'S|0⟩=TX|1⟩',
  'HIH|0⟩=|0⟩',
  'S|+⟩=SH|0⟩',
  '|+⟩=XXZ|-⟩',
  '|-⟩=YYI|-⟩',
  'TI|+⟩=T|+⟩',
  'SX|1⟩=S|0⟩',
  '|0⟩=SZS|0⟩',
  '|0⟩=TIS|0⟩',
  'S-|0⟩=-|0⟩',
  'STT|+⟩=|-⟩',
  'X-|-⟩=H|1⟩',
  'HTZ|0⟩=|+⟩',
  'XX|0⟩=X|1⟩',
  '|1⟩=HHX|0⟩',
  '|+⟩=HZZ|0⟩',
  'X|1⟩=IH|+⟩',
  '|1⟩=XTZ|0⟩',
  '|1⟩=HZI|+⟩',
  'S|0⟩=ST|0⟩',
  'IZ|+⟩=I|-⟩',
  '|0⟩=HZH|1⟩',
  'IH|+⟩=T|0⟩',
  '|+⟩=HZS|0⟩',
  'XSI|0⟩=|1⟩',
  'T|0⟩=TT|0⟩',
  '|-⟩=ZIH|0⟩',
  'ZHH|+⟩=|-⟩',
  'IY|-⟩=Y|-⟩',
  'X|+⟩=HH|+⟩',
  'ZT|0⟩=Z|0⟩',
  'YZ|0⟩=S|1⟩',
  'S|1⟩=YI|0⟩',
  'TZS|0⟩=|0⟩',
  'YZ|-⟩=Y|+⟩',
  '-|0⟩=X-|1⟩',
  'XI|+⟩=X|+⟩',
  '|0⟩=XXS|0⟩',
  'ZZT|0⟩=|0⟩',
  'IIZ|+⟩=|-⟩',
  'ZT|0⟩=X|1⟩',
  'Y|i+⟩=|i+⟩',
  'XXX|1⟩=|0⟩',
  '|1⟩=HX-|-⟩',
  'X|1⟩=ZT|0⟩',
  'ZZ|1⟩=X|0⟩',
  'HS|0⟩=H|0⟩',
  'ZII|0⟩=|0⟩',
  'TIS|0⟩=|0⟩',
  '|-⟩=HXS|0⟩',
  'XZX|1⟩=|1⟩',
  '|0⟩=HYY|+⟩',
  'SH|-⟩=S|1⟩',
  'XHH|1⟩=|0⟩',
  'Z-|1⟩=X|0⟩',
  'HIZ|0⟩=|+⟩',
  'Z|-⟩=ZI|-⟩',
  'HX|-⟩=Z|1⟩',
  'SXX|0⟩=|0⟩',
  'X-|0⟩=Z|1⟩',
  'IZZ|+⟩=|+⟩',
  'XYY|+⟩=|+⟩',
  'ZTT|0⟩=|0⟩',
  '|+⟩=XHH|+⟩',
  '|0⟩=TZZ|0⟩',
  'ZSI|0⟩=|0⟩',
  '|0⟩=SIX|1⟩',
  'TT|+⟩=S|+⟩',
  '|i-⟩=SI|-⟩',
  'HTX|1⟩=|+⟩',
  'SZ|0⟩=I|0⟩',
  '-|+⟩=Z-|-⟩',
  '|+⟩=ZHH|-⟩',
  'HSZ|0⟩=|+⟩',
  'ZZ|0⟩=I|0⟩',
  'ZH|+⟩=I|0⟩',
  'YX|0⟩=Y|1⟩',
  'H|0⟩=S|i-⟩',
  'STS|0⟩=|0⟩',
  'I|0⟩=IT|0⟩',
  'Z|+⟩=HH|-⟩',
  'IIH|+⟩=|0⟩',
  'TIZ|0⟩=|0⟩',
  '|-⟩=ZXI|+⟩',
  'HX|+⟩=T|0⟩',
  'I|0⟩=TI|0⟩',
  'XX|-⟩=Z|+⟩',
  '|+⟩=HZT|0⟩',
  'I|0⟩=IS|0⟩',
  '|0⟩=ZTZ|0⟩',
  'S|i+⟩=I|-⟩',
  'ZX|1⟩=T|0⟩',
  'YYH|-⟩=|1⟩',
  '|0⟩=SSZ|0⟩',
  'Z|1⟩=H-|-⟩',
  'TX|1⟩=X|1⟩',
  'YYI|-⟩=|-⟩',
  '|0⟩=ISS|0⟩',
  'XIZ|-⟩=|+⟩',
  'HXI|0⟩=|-⟩',
  '|1⟩=HHH|-⟩',
  'H|-⟩=XH|+⟩',
  'H|+⟩=IH|+⟩',
  'Y|0⟩=YS|0⟩',
  'XX|-⟩=I|-⟩',
  'HX|+⟩=Z|0⟩',
  'S|1⟩=SI|1⟩',
  'HHZ|0⟩=|0⟩',
  'IZX|1⟩=|0⟩',
  'XX|0⟩=H|+⟩',
  'XTX|1⟩=|1⟩',
  'HZZ|-⟩=|1⟩',
  'Z|0⟩=YS|1⟩',
  'IX|1⟩=S|0⟩',
  'ITX|1⟩=|0⟩',
  'XHS|0⟩=|+⟩',
  'IZI|+⟩=|-⟩',
  'H|0⟩=YY|+⟩',
  'X|1⟩=TI|0⟩',
  'I|0⟩=ZT|0⟩',
  'IS|+⟩=S|+⟩',
  '|1⟩=ZZH|-⟩',
  'TZ|0⟩=H|+⟩',
  'ZII|+⟩=|-⟩',
  '|1⟩=HII|-⟩',
  'I-|-⟩=X|-⟩',
  'IX|0⟩=H|-⟩',
  'II|0⟩=T|0⟩',
  'SS|1⟩=Z|1⟩',
  'I|+⟩=XH|0⟩',
  '|-⟩=HII|1⟩',
  'HYY|0⟩=|+⟩',
  'T|+⟩=ZT|-⟩',
  'I|0⟩=HX|+⟩',
  '|0⟩=IXH|-⟩',
  '|1⟩=YYX|0⟩',
  'H-|1⟩=-|-⟩',
  'IS|0⟩=S|0⟩',
  '-|0⟩=Z-|0⟩',
  'S|0⟩=TI|0⟩',
  'YY|0⟩=S|0⟩',
  'Z|i+⟩=S|-⟩',
  'T|0⟩=ZT|0⟩',
  'X|1⟩=TH|+⟩',
  'SS|0⟩=Z|0⟩',
  'ZZH|0⟩=|+⟩',
  '|0⟩=THH|0⟩',
  'XST|0⟩=|1⟩',
  'H|-⟩=HZ|+⟩',
  'HXZ|-⟩=|0⟩',
  'SY|0⟩=Z|1⟩',
  'IHZ|+⟩=|1⟩',
  'I|+⟩=XZ|-⟩',
  'XX|1⟩=H|-⟩',
  'I|+⟩=ZZ|+⟩',
  'ZY|1⟩=Y|1⟩',
  'III|0⟩=|0⟩',
  'T|1⟩=IT|1⟩',
  'HXI|1⟩=|+⟩',
  'SH|+⟩=H|+⟩',
  'ZZ|1⟩=H|-⟩',
  'T|0⟩=XH|-⟩',
  'S|+⟩=I|i+⟩',
  'HZX|+⟩=|1⟩',
  'II|1⟩=H|-⟩',
  'Z|1⟩=SS|1⟩',
  '|0⟩=HXX|+⟩',
  'TH|1⟩=T|-⟩',
  '|1⟩=SSZ|1⟩',
  'Z|-⟩=HZ|0⟩',
  '|+⟩=IIX|+⟩',
  '|0⟩=ITZ|0⟩',
  'TT|+⟩=|i+⟩',
  'X|+⟩=YY|+⟩',
  'Z|i-⟩=|i+⟩',
  'SSZ|+⟩=|+⟩',
  'SI|0⟩=X|1⟩',
  '|1⟩=XSI|0⟩',
  'IZZ|-⟩=|-⟩',
  'I-|0⟩=-|0⟩',
  '|+⟩=HIT|0⟩',
  '|1⟩=HZH|0⟩',
  '|1⟩=IIX|0⟩',
  'ISX|1⟩=|0⟩',
  'HI|+⟩=I|0⟩',
  'S|i+⟩=Z|+⟩',
  '-|-⟩=IX|-⟩',
  '|0⟩=SZH|+⟩',
  'I|+⟩=HT|0⟩',
  'Z|-⟩=IX|+⟩',
  '-|-⟩=I-|-⟩',
  '|1⟩=YZY|1⟩',
  '|-⟩=IZX|+⟩',
  'YY|-⟩=I|-⟩',
  'IX|+⟩=H|0⟩',
  'SX|1⟩=X|1⟩',
  'X|0⟩=YY|1⟩',
  '|+⟩=HXH|-⟩',
  'IT|0⟩=H|+⟩',
  'ZS|0⟩=S|0⟩',
  'HS|0⟩=I|+⟩',
  'HH|+⟩=I|+⟩',
  '|0⟩=HZI|-⟩',
  '|+⟩=XHS|0⟩',
  'T|0⟩=SS|0⟩',
  'STH|+⟩=|0⟩',
  'YH|+⟩=S|1⟩',
  'T|0⟩=TZ|0⟩',
  'XXX|+⟩=|+⟩',
  '|+⟩=SZS|+⟩',
  '|-⟩=SI|i+⟩',
  '|-⟩=SSH|0⟩',
  'I|0⟩=SI|0⟩',
  'TTX|1⟩=|0⟩',
  '|0⟩=ZTX|1⟩',
  'ZS|+⟩=|i-⟩',
  '|+⟩=HZH|+⟩',
  'SI|1⟩=Y|0⟩',
  'XHZ|1⟩=|-⟩',
  'ZHI|0⟩=|-⟩',
  'IHZ|-⟩=|0⟩',
  'SZ|0⟩=H|+⟩',
  '|0⟩=YYI|0⟩',
  '|0⟩=ZXI|1⟩',
  'ZZ|1⟩=I|1⟩',
  'ZZ|0⟩=H|+⟩',
  'I|1⟩=Z-|1⟩',
  'H|+⟩=IT|0⟩',
  'S|-⟩=I|i-⟩',
  '|0⟩=TTH|+⟩',
  'IT|0⟩=T|0⟩',
  'I|0⟩=ZI|0⟩',
  '|0⟩=ISX|1⟩',
  '|+⟩=HIS|0⟩',
  'HIH|+⟩=|+⟩',
  '|i+⟩=SX|+⟩',
  'H|0⟩=IX|+⟩',
  'X|1⟩=SI|0⟩',
  'X|+⟩=IX|+⟩',
  'I|1⟩=II|1⟩',
  '-|+⟩=H-|0⟩',
  'HZ|-⟩=T|0⟩',
  'HTT|0⟩=|+⟩',
  '|+⟩=HST|0⟩',
  'T|0⟩=TI|0⟩',
  'I|1⟩=XI|0⟩',
  '|0⟩=ZST|0⟩',
  '|+⟩=HTZ|0⟩',
  'SI|-⟩=|i-⟩',
  '|0⟩=TSX|1⟩',
  'ZX|+⟩=Z|+⟩',
  'XI|1⟩=S|0⟩',
  'T|0⟩=ZX|1⟩',
  'SI|1⟩=S|1⟩',
  'YY|-⟩=Z|+⟩',
  'S|i-⟩=Z|-⟩',
  'X|-⟩=H-|1⟩',
  '|1⟩=IXX|1⟩',
  'IHH|0⟩=|0⟩',
  'ISZ|0⟩=|0⟩',
  'IZ|1⟩=-|1⟩',
  'HST|0⟩=|+⟩',
  'IIH|0⟩=|+⟩',
  'IX|0⟩=I|1⟩',
  '|0⟩=IST|0⟩',
  'YS|1⟩=S|0⟩',
  'X|1⟩=HI|+⟩',
  'XY|-⟩=Y|-⟩',
  'ZH|1⟩=X|+⟩',
  'IT|+⟩=T|+⟩',
  'I|0⟩=ST|0⟩',
  '|0⟩=TII|0⟩',
  'I-|+⟩=-|+⟩',
  'IZX|+⟩=|-⟩',
  'SSS|0⟩=|0⟩',
  'X|0⟩=IX|0⟩',
  'TS|0⟩=H|+⟩',
  'XYS|1⟩=|1⟩',
  '|-⟩=ZZI|-⟩',
  '|0⟩=SYS|1⟩',
  'H|+⟩=SX|1⟩',
  'YY|0⟩=I|0⟩',
  'IXZ|-⟩=|+⟩',
  'YY|0⟩=X|1⟩',
  'HI|+⟩=H|+⟩',
  'I|-⟩=XX|-⟩',
  '|+⟩=HYY|0⟩',
  'ZH|1⟩=H|0⟩',
  'HZI|+⟩=|1⟩',
  'H|0⟩=IZ|-⟩',
  '-|1⟩=ZH|-⟩',
  'ZIS|0⟩=|0⟩',
  'H|-⟩=IH|-⟩',
  'ZHZ|0⟩=|-⟩',
  'ZI|1⟩=-|1⟩',
  'Y|-⟩=XY|-⟩',
  '|+⟩=XHX|1⟩',
  'H|+⟩=ZX|1⟩',
  '|0⟩=TZT|0⟩',
  '|0⟩=XIX|0⟩',
  'I|0⟩=TS|0⟩',
  '|0⟩=YYZ|0⟩',
  'IH|-⟩=H|-⟩',
  'IXZ|0⟩=|1⟩',
  'T|0⟩=TX|1⟩',
  'IT|0⟩=S|0⟩',
  'X|+⟩=XX|+⟩',
  'II|0⟩=X|1⟩',
  'S|+⟩=SI|+⟩',
  'TIX|1⟩=|0⟩',
  'YS|1⟩=T|0⟩',
  'SX|1⟩=H|+⟩',
  'TI|0⟩=H|+⟩',
  'IX-|-⟩=|-⟩',
  'Y|+⟩=IY|+⟩',
  'H|-⟩=HI|-⟩',
  '|0⟩=YIS|1⟩',
  'S|-⟩=IS|-⟩',
  'I|+⟩=XX|+⟩',
  'IS|i-⟩=|+⟩',
  '|0⟩=TTS|0⟩',
  'ST|0⟩=S|0⟩',
  '|0⟩=HSS|-⟩',
  'Y|0⟩=YI|0⟩',
  'H|0⟩=XH|0⟩',
  'S|-⟩=Z|i+⟩',
  'ZS|0⟩=H|+⟩',
  '|0⟩=XXZ|0⟩',
  'Z|0⟩=XI|1⟩',
  '|0⟩=TXI|1⟩',
  'TIT|0⟩=|0⟩',
  'YY|+⟩=I|+⟩',
  'YSX|0⟩=|0⟩',
  'T|0⟩=XI|1⟩',
  'IZ|0⟩=T|0⟩',
  'T|-⟩=TI|-⟩',
  'XX|1⟩=I|1⟩',
  'XZS|0⟩=|1⟩',
  '|+⟩=HXX|0⟩',
  '|1⟩=SXY|1⟩',
  'HZT|0⟩=|+⟩',
  'STT|-⟩=|+⟩',
  'HT|0⟩=H|0⟩',
  'TY|1⟩=Y|1⟩',
  'ZI|1⟩=Z|1⟩',
  'ZT|-⟩=T|+⟩',
  'HX|+⟩=I|0⟩',
  '|+⟩=SSI|-⟩',
  '|+⟩=STT|-⟩',
  'SIH|+⟩=|0⟩',
  'Z|0⟩=HH|0⟩',
  'XHH|+⟩=|+⟩',
  'ZZX|+⟩=|+⟩',
  'S|1⟩=YZ|0⟩',
  'ZZ|0⟩=T|0⟩',
  '|-⟩=ZXX|+⟩',
  '|+⟩=HZI|0⟩',
  'XHZ|0⟩=|+⟩',
  'IT|0⟩=Z|0⟩',
  '|0⟩=SXX|0⟩',
  '|-⟩=HHH|1⟩',
  'I|1⟩=IX|0⟩',
  'H|+⟩=TZ|0⟩',
  'Z|i+⟩=|i-⟩',
  '|0⟩=HHX|1⟩',
  'Z|0⟩=II|0⟩',
  'H|1⟩=X-|-⟩',
  '|0⟩=SHH|0⟩',
  '|-⟩=HXT|0⟩',
  'S|0⟩=IS|0⟩',
  'YS|0⟩=S|1⟩',
  'Z|0⟩=IX|1⟩',
  'I|0⟩=TX|1⟩',
  'XH|-⟩=I|0⟩',
  'I-|1⟩=-|1⟩',
  'TZ|+⟩=T|-⟩',
  'YY|+⟩=X|+⟩',
  'IZH|+⟩=|0⟩',
  'SZ|+⟩=S|-⟩',
  '|0⟩=ZTS|0⟩',
  'HI|0⟩=Z|-⟩',
  'H|-⟩=XT|0⟩',
  'YYZ|+⟩=|-⟩',
  'YYI|0⟩=|0⟩',
  '|1⟩=XXI|1⟩',
  'XH|0⟩=H|0⟩',
  'IX|1⟩=I|0⟩',
  '|1⟩=IHI|-⟩',
  'IS|0⟩=Z|0⟩',
  '|+⟩=HHZ|-⟩',
  'IZ|0⟩=X|1⟩',
  '|0⟩=SIZ|0⟩',
  'ZH|0⟩=Z|+⟩',
  'I|-⟩=ZH|0⟩',
  'I|+⟩=IH|0⟩',
  'TYY|0⟩=|0⟩',
  'H|+⟩=ZH|+⟩',
  'XTI|0⟩=|1⟩',
  'XHH|0⟩=|1⟩',
  'XS|0⟩=X|0⟩',
  'Z|1⟩=ZH|-⟩',
  '|0⟩=TIT|0⟩',
  'XI-|-⟩=|-⟩',
  'TH|+⟩=X|1⟩',
  'I|0⟩=HZ|-⟩',
  '|0⟩=HXI|+⟩',
  '|-⟩=III|-⟩',
  'Z|+⟩=HI|1⟩',
  'XZ-|1⟩=|0⟩',
  '|+⟩=IZI|-⟩',
  '-|+⟩=I-|+⟩',
  'S|0⟩=XX|0⟩',
  'XI|1⟩=X|1⟩',
  '|0⟩=STZ|0⟩',
  'ZHT|0⟩=|-⟩',
  '|0⟩=ZHX|+⟩',
  'T|0⟩=SZ|0⟩',
  '|0⟩=III|0⟩',
  'I|-⟩=ZX|+⟩',
  'TTI|0⟩=|0⟩',
  'Z|-⟩=II|+⟩',
  'IZ|+⟩=Z|+⟩',
  'Z|+⟩=XX|-⟩',
  'XH-|1⟩=|-⟩',
  '|0⟩=YSI|1⟩',
  'III|1⟩=|1⟩',
  'TX|+⟩=T|+⟩',
  '|1⟩=IYY|1⟩',
  'HS|0⟩=Z|-⟩',
  '|0⟩=XZ-|1⟩',
  'HX|+⟩=X|1⟩',
  'Z|0⟩=IS|0⟩',
  'ZI|0⟩=X|1⟩',
  'X|+⟩=HX|1⟩',
  'XHI|-⟩=|0⟩',
  'HZ|0⟩=X|+⟩',
  'YYT|0⟩=|0⟩',
  '|1⟩=III|1⟩',
  'SH|+⟩=T|0⟩',
  'T|+⟩=TI|+⟩',
  '|0⟩=XXT|0⟩',
  'XIX|1⟩=|1⟩',
  'Y|+⟩=YX|+⟩',
  '|0⟩=SXI|1⟩',
  'ZSY|0⟩=|1⟩',
  'I|0⟩=YS|1⟩',
  'HT|0⟩=Z|-⟩',
  '|+⟩=ZXX|-⟩',
  'ZI|0⟩=S|0⟩',
  'H|1⟩=HX|0⟩',
  'IIX|+⟩=|+⟩',
  'HYY|-⟩=|1⟩',
  'XH|-⟩=S|0⟩',
  'XXT|0⟩=|0⟩',
  'I|+⟩=XI|+⟩',
  '-|0⟩=H-|+⟩',
  'HYY|1⟩=|-⟩',
  'TTS|0⟩=|0⟩',
  '|0⟩=SHX|+⟩',
  'ZH|+⟩=S|0⟩',
  'TS|0⟩=Z|0⟩',
  'ZZX|1⟩=|0⟩',
  'HZ-|1⟩=|-⟩',
  '|0⟩=TZS|0⟩',
  'ZS|0⟩=I|0⟩',
  '|+⟩=ZHI|1⟩',
  'Z|0⟩=YY|0⟩',
  'H|0⟩=HH|+⟩',
  '|1⟩=IHZ|+⟩',
  'II|+⟩=H|0⟩',
  'HII|+⟩=|0⟩',
  'Z|-⟩=ZZ|+⟩',
  'SX|+⟩=S|+⟩',
  'Y|0⟩=TT|1⟩',
  'ZIH|0⟩=|-⟩',
  'II|-⟩=I|-⟩',
  'SZZ|0⟩=|0⟩',
  '|1⟩=HYY|-⟩',
  '|0⟩=ZII|0⟩',
  'SHH|0⟩=|0⟩',
  'HHH|+⟩=|0⟩',
  'Z|0⟩=TS|0⟩',
  'YIY|-⟩=|-⟩',
  '-|1⟩=SS|1⟩',
  'YYX|0⟩=|1⟩',
  'I|+⟩=II|+⟩',
  'TT|1⟩=Y|0⟩',
  'YY|-⟩=H|1⟩',
  '-|0⟩=I-|0⟩',
  '|i+⟩=ZS|-⟩',
  'II|1⟩=I|1⟩',
  'II|+⟩=Z|-⟩',
  '|+⟩=XXI|+⟩',
  'T|0⟩=TS|0⟩',
  'ZSZ|0⟩=|0⟩',
  'XS|0⟩=I|1⟩',
  'ZH|0⟩=I|-⟩',
  'X|1⟩=ZH|+⟩',
  'SX|+⟩=|i+⟩',
  'ZZX|0⟩=|1⟩',
  'Z|0⟩=ST|0⟩',
  'SSZ|-⟩=|-⟩',
  'H|+⟩=YY|0⟩',
  '|0⟩=TYS|1⟩',
  '|0⟩=YTT|1⟩',
  'Z|-⟩=HX|1⟩',
  '|0⟩=ZTH|+⟩',
  'SY|1⟩=Y|1⟩',
  '|0⟩=ZYY|0⟩',
  'ZHH|0⟩=|0⟩',
  'TZX|1⟩=|0⟩',
  'SZ|0⟩=S|0⟩',
  'TTS|-⟩=|+⟩',
  'XTZ|0⟩=|1⟩',
  'Z|-⟩=XX|+⟩',
  'H-|-⟩=Z|1⟩',
  '|0⟩=ZXH|-⟩',
  'IX|1⟩=X|1⟩',
  'ZXI|+⟩=|-⟩',
  'SS|-⟩=X|+⟩',
  'YS|1⟩=I|0⟩',
  'X|1⟩=SH|+⟩',
  'IXI|0⟩=|1⟩',
  'HH|1⟩=H|-⟩',
  'ZI-|1⟩=|1⟩',
  'I|+⟩=HX|1⟩',
  'TZZ|0⟩=|0⟩',
  'YYS|0⟩=|0⟩',
  'TST|-⟩=|+⟩',
  '|0⟩=SZT|0⟩',
  'TZ|0⟩=Z|0⟩',
  '|0⟩=IHI|+⟩',
  'H|+⟩=SS|0⟩',
  'HZ|-⟩=Z|0⟩',
  'HIZ|-⟩=|0⟩',
  'XSS|0⟩=|1⟩',
  'H|0⟩=II|+⟩',
  '|1⟩=HS|i+⟩',
  '|+⟩=IHZ|0⟩',
  '|-⟩=HHI|-⟩',
  'H|+⟩=IS|0⟩',
  '|i+⟩=SZ|-⟩',
  'I|0⟩=IZ|0⟩',
  'Z|0⟩=SZ|0⟩',
  '|1⟩=HZZ|-⟩',
  'ZI|0⟩=H|+⟩',
  'IHI|0⟩=|+⟩',
  'Z|1⟩=SY|0⟩',
  'HI|-⟩=H|-⟩',
  'ZI|+⟩=Z|+⟩',
  '|+⟩=SSH|1⟩',
  '|0⟩=IHZ|-⟩',
  'IZZ|1⟩=|1⟩',
  'H|1⟩=HH|-⟩',
  'SZY|0⟩=|1⟩',
  'IZI|0⟩=|0⟩',
  'Z|1⟩=ZX|0⟩',
  '|-⟩=IHH|-⟩',
  'X|1⟩=TZ|0⟩',
  'STT|0⟩=|0⟩',
  'IHZ|0⟩=|+⟩',
  'ITT|0⟩=|0⟩',
  'X|1⟩=SZ|0⟩',
  '|1⟩=ZHX|-⟩',
  'X|1⟩=XX|0⟩',
  'HI|+⟩=T|0⟩',
  'XSX|1⟩=|1⟩',
  '|0⟩=SYY|0⟩',
  '|1⟩=IHH|1⟩',
  'S|0⟩=SX|1⟩',
  'Z|1⟩=I-|1⟩',
  'I|0⟩=ZS|0⟩',
  'S|1⟩=YX|1⟩',
  'T|0⟩=HI|+⟩',
  'HIH|-⟩=|-⟩',
  'TX|1⟩=H|+⟩',
  '|1⟩=ZH-|-⟩',
  '|-⟩=STT|+⟩',
  '|+⟩=IYY|+⟩',
  '|+⟩=XS|i-⟩',
  'ZZ|+⟩=H|0⟩',
  'YTT|1⟩=|0⟩',
  'XHX|1⟩=|+⟩',
  'HHH|0⟩=|+⟩',
  'SZ|i-⟩=|-⟩',
  'S|0⟩=HH|0⟩',
  'X|-⟩=XZ|+⟩',
  'YSH|-⟩=|0⟩',
  'IHT|0⟩=|+⟩',
  'Z|+⟩=ZH|0⟩',
  'X|+⟩=SS|-⟩',
  'I|1⟩=XS|0⟩',
  'T|-⟩=TH|1⟩',
  'YS|1⟩=X|1⟩',
  '|+⟩=IIZ|-⟩',
  'SZS|+⟩=|+⟩',
  'T|0⟩=ZI|0⟩',
  '|-⟩=SZ|i-⟩',
  'H|+⟩=YS|1⟩',
  'S|0⟩=TT|0⟩',
  'Z|0⟩=TH|+⟩',
  'X|-⟩=Z-|+⟩',
  'Z|-⟩=IH|0⟩',
  'T|0⟩=II|0⟩',
  '|+⟩=HTX|1⟩',
  'ZX|1⟩=X|1⟩',
  'XTH|+⟩=|1⟩',
  'ZIH|1⟩=|+⟩',
  'IZ|1⟩=Z|1⟩',
  'ZIT|0⟩=|0⟩',
  'X|-⟩=XH|1⟩',
  'YH|1⟩=Y|-⟩',
  'ZS|-⟩=S|+⟩',
  '|+⟩=XZH|1⟩',
  'I|1⟩=XX|1⟩',
  'SHX|+⟩=|0⟩',
  'X|+⟩=XH|0⟩',
  'TII|0⟩=|0⟩',
  '|1⟩=XIX|1⟩',
  'HTH|+⟩=|+⟩',
  'H|+⟩=HH|0⟩',
  '|+⟩=HIZ|0⟩',
  'SIZ|0⟩=|0⟩',
  '|0⟩=IZI|0⟩',
  'Y|0⟩=YH|+⟩',
  'HIH|1⟩=|1⟩',
  'X|1⟩=YY|0⟩',
  'T|0⟩=IZ|0⟩',
  'TI|0⟩=I|0⟩',
  'HX|+⟩=H|+⟩',
  '|i+⟩=Z|i-⟩',
  'ZSX|1⟩=|0⟩',
  'HI|+⟩=Z|0⟩',
  'Y|0⟩=YT|0⟩',
  '|0⟩=IZH|+⟩',
  'ZXX|+⟩=|-⟩',
  'IZ|-⟩=H|0⟩',
  '|-⟩=HXH|+⟩',
  'IXX|1⟩=|1⟩',
  '|0⟩=TIH|+⟩',
  'ZH|+⟩=Z|0⟩',
  'X|1⟩=YS|1⟩',
  '-|1⟩=ZI|1⟩',
  'ST|0⟩=H|+⟩',
  'YY|1⟩=H|-⟩',
  'I|i-⟩=S|-⟩',
  'TSI|0⟩=|0⟩',
  '|+⟩=XXH|0⟩',
  'HXX|1⟩=|-⟩',
  'ZHS|0⟩=|-⟩',
  'Z-|1⟩=H|-⟩',
  'S|1⟩=IY|0⟩',
  'SYS|1⟩=|0⟩',
  'TXH|-⟩=|0⟩',
  'YZ|+⟩=Y|-⟩',
  'H|+⟩=ST|0⟩',
  'IXI|1⟩=|0⟩',
  '|0⟩=TYY|0⟩',
  'T|0⟩=SI|0⟩',
  '|i-⟩=IS|-⟩',
  '|0⟩=TTZ|0⟩',
  'HZI|-⟩=|0⟩',
  '|1⟩=XTI|0⟩',
  'ZZ|+⟩=Z|-⟩',
  'IIT|0⟩=|0⟩',
  'XH|0⟩=Z|-⟩',
  'ZS|0⟩=T|0⟩',
  'XX|0⟩=T|0⟩',
  'Y|-⟩=YH|1⟩',
  '|0⟩=ZSZ|0⟩',
  'XZ|1⟩=-|0⟩',
  'T|0⟩=IX|1⟩',
  'I|1⟩=XH|+⟩',
  'HZ|-⟩=H|+⟩',
  'X|0⟩=HZ|+⟩',
  'ZZ|-⟩=Z|+⟩',
  'TX|0⟩=T|1⟩',
  'X|+⟩=II|+⟩',
  'XIZ|0⟩=|1⟩',
  'ZH|-⟩=-|1⟩',
  '|0⟩=TXH|-⟩',
  '|0⟩=ZZZ|0⟩',
  'ZHH|-⟩=|+⟩',
  'ZI|-⟩=H|0⟩',
  '|0⟩=IHH|0⟩',
  '|0⟩=HHT|0⟩',
  'ZZZ|-⟩=|+⟩',
  'YYZ|0⟩=|0⟩',
  'IZ|+⟩=H|1⟩',
  'X|+⟩=XI|+⟩',
  '|-⟩=IIZ|+⟩',
  'YSI|1⟩=|0⟩',
  'IZH|1⟩=|+⟩',
  'XXH|-⟩=|1⟩',
  'ZX-|-⟩=|+⟩',
  'T|0⟩=SX|1⟩',
  'IT|0⟩=X|1⟩',
  'XIX|0⟩=|0⟩',
  'HH|0⟩=T|0⟩',
  'YY|0⟩=Z|0⟩',
  'HI|0⟩=X|+⟩',
  '|-⟩=ZHS|0⟩',
  'YYI|1⟩=|1⟩',
  'TST|+⟩=|-⟩',
  'X|+⟩=HI|0⟩',
  'YS|1⟩=H|+⟩',
  '|0⟩=HHZ|0⟩',
  'SY|0⟩=-|1⟩',
  'HIZ|+⟩=|1⟩',
  '|0⟩=HS|i-⟩',
  'SSI|0⟩=|0⟩',
  'SS|0⟩=X|1⟩',
  '|-⟩=XZ-|+⟩',
  'XXH|0⟩=|+⟩',
  '|-⟩=ZHI|0⟩',
  '|-⟩=SSZ|-⟩',
  '|i-⟩=Z|i+⟩',
  'SS|-⟩=I|+⟩',
  'Z|+⟩=S|i+⟩',
  'T|0⟩=IS|0⟩',
  '|i+⟩=I|i+⟩',
  '|1⟩=XHX|+⟩',
  'Z-|+⟩=X|-⟩',
  'I|0⟩=ZH|+⟩',
  'ZI|+⟩=H|1⟩',
  'XZH|1⟩=|+⟩',
  'Z|0⟩=HZ|-⟩',
  'ZI|0⟩=Z|0⟩',
  'XZ|+⟩=-|-⟩',
  '|0⟩=ITH|+⟩',
  'SII|0⟩=|0⟩',
  'IS|+⟩=|i+⟩',
  'THI|+⟩=|0⟩',
  'I|0⟩=XH|-⟩',
  'HX|0⟩=H|1⟩',
  'SI|0⟩=S|0⟩',
  'H-|-⟩=-|1⟩',
  'Y|0⟩=YX|1⟩',
  'ITH|+⟩=|0⟩',
  '|+⟩=YYZ|-⟩',
  '|0⟩=STT|0⟩',
  '|0⟩=TIZ|0⟩',
  '|-⟩=IIH|1⟩',
  '|+⟩=IHS|0⟩',
  'ZIH|+⟩=|0⟩',
  '|0⟩=ZIT|0⟩',
  '|-⟩=ZIX|+⟩',
  'H|1⟩=IZ|+⟩',
  'ZS|i+⟩=|+⟩',
  'SI|i-⟩=|+⟩',
  'TT|0⟩=Z|0⟩',
  '|-⟩=IZI|+⟩',
  'SZ|+⟩=|i-⟩',
  '|1⟩=IZ-|1⟩',
  'H|1⟩=S|i+⟩',
  'SX|1⟩=Z|0⟩',
  'SI|+⟩=S|+⟩',
  'HZZ|+⟩=|0⟩',
  'XII|0⟩=|1⟩',
  '|+⟩=XXX|+⟩',
  'Z|+⟩=ZZ|-⟩',
  '|+⟩=IIH|0⟩',
  'S|0⟩=ZI|0⟩',
  'SS|1⟩=-|1⟩',
  'S|0⟩=HI|+⟩',
  '|1⟩=XSX|1⟩',
  'Z-|0⟩=-|0⟩',
  'X|1⟩=TS|0⟩',
  '|+⟩=XIZ|-⟩',
  '|-⟩=ZHZ|0⟩',
  '|0⟩=TZX|1⟩',
  '|-⟩=ZII|+⟩',
  '|-⟩=YIY|-⟩',
  'IS|i+⟩=|-⟩',
  'H|-⟩=XX|1⟩',
  'HX|-⟩=-|1⟩',
  'XH|+⟩=X|0⟩',
  'HH|0⟩=X|1⟩',
  'SZT|0⟩=|0⟩',
  'II|0⟩=I|0⟩',
  'S|+⟩=Y|i+⟩',
  '|0⟩=IIZ|0⟩',
  'HSS|0⟩=|+⟩',
  'IT|1⟩=T|1⟩',
  '|+⟩=SSZ|+⟩',
  'YYH|1⟩=|-⟩',
  'IZ|0⟩=H|+⟩',
  '|0⟩=YYT|0⟩',
  'H|0⟩=HT|0⟩',
  'XTS|0⟩=|1⟩',
  'HT|0⟩=X|+⟩',
  'I|-⟩=HH|-⟩',
  'IYY|0⟩=|0⟩',
  'ZYY|+⟩=|-⟩',
  '|+⟩=IHX|1⟩',
  'T|0⟩=ZZ|0⟩',
  'YIY|+⟩=|+⟩',
  'SH|0⟩=|i+⟩',
  'I-|-⟩=-|-⟩',
  'ZTZ|0⟩=|0⟩',
  'ZSS|1⟩=|1⟩',
  'I|0⟩=ZX|1⟩',
  'IXH|+⟩=|1⟩',
  'H|0⟩=IH|0⟩',
  '|0⟩=ISZ|0⟩',
  '|-⟩=YYZ|+⟩',
  '|+⟩=XZZ|+⟩',
  '|0⟩=HIH|0⟩',
  'H-|+⟩=-|0⟩',
  'S|1⟩=YT|0⟩',
  'T|-⟩=ZT|+⟩',
  'ZYS|1⟩=|0⟩',
  'HZS|0⟩=|+⟩',
  'TS|0⟩=S|0⟩',
  'HYY|+⟩=|0⟩',
  'Y|1⟩=SY|1⟩',
  '|0⟩=IZZ|0⟩',
  'S|0⟩=ZX|1⟩',
  '|+⟩=HSZ|0⟩',
  'ZXH|0⟩=|-⟩',
  '|1⟩=XTX|1⟩',
  '|i+⟩=YS|+⟩',
  'S|0⟩=ZH|+⟩',
  'Z|0⟩=XH|-⟩',
  'SX|0⟩=Y|0⟩',
  'HS|i+⟩=|1⟩',
  'H|+⟩=XX|0⟩',
  'XX|+⟩=H|0⟩',
  '|1⟩=SZY|0⟩',
  'X|1⟩=ST|0⟩',
  'Z|-⟩=ZH|1⟩',
  'H|+⟩=IX|1⟩',
  'T|0⟩=IH|+⟩',
  'SSI|-⟩=|+⟩',
  'IHX|0⟩=|-⟩',
  'HZZ|0⟩=|+⟩',
  '|i-⟩=TT|-⟩',
  'X|0⟩=HH|1⟩',
  'Z|1⟩=IZ|1⟩',
  'S|0⟩=YY|0⟩',
  'YIS|1⟩=|0⟩',
  'H-|1⟩=X|-⟩',
  'S|1⟩=SX|0⟩',
  '|0⟩=THZ|-⟩',
  'IS|0⟩=H|+⟩',
  '|0⟩=HHH|+⟩',
  '|-⟩=XHZ|1⟩',
  '|-⟩=YYH|1⟩',
  'Z|0⟩=ZT|0⟩',
  '|0⟩=TTI|0⟩',
  '|0⟩=XYY|1⟩',
  'XI|0⟩=H|-⟩',
  'HH|+⟩=H|0⟩',
  'IH|1⟩=I|-⟩',
  '|+⟩=HZX|1⟩',
  '|+⟩=ISS|-⟩',
  'T|1⟩=TX|0⟩',
  'SS|0⟩=H|+⟩',
  'HSS|+⟩=|1⟩',
  'IIZ|0⟩=|0⟩',
  'TZT|0⟩=|0⟩',
  'Z|-⟩=XZ|-⟩',
  'XXI|+⟩=|+⟩',
  'T|0⟩=ZH|+⟩',
  'ST|0⟩=T|0⟩',
  '|1⟩=XIZ|0⟩',
  'XTT|0⟩=|1⟩',
  'TTS|+⟩=|-⟩',
  '|1⟩=XIT|0⟩',
  'T|+⟩=TH|0⟩',
  'IZ|-⟩=X|+⟩',
  'H|0⟩=HS|0⟩',
  'S|-⟩=ZS|+⟩',
  '|-⟩=SYS|+⟩',
  'H|-⟩=XZ|0⟩',
  '|1⟩=XZS|0⟩',
  'SH|0⟩=S|+⟩',
  'YH|0⟩=Y|+⟩',
  '|0⟩=STS|0⟩',
  'Y|-⟩=IY|-⟩',
  '|1⟩=HZX|+⟩',
  'H|-⟩=YY|1⟩',
  'IH|+⟩=I|0⟩',
  'ISS|-⟩=|+⟩',
  '|1⟩=XZX|1⟩',
  'THZ|-⟩=|0⟩',
  'X|0⟩=II|1⟩',
  'SSH|+⟩=|0⟩',
  'IX|+⟩=X|+⟩',
  'H|+⟩=TS|0⟩',
  'SSX|+⟩=|-⟩',
  'H|0⟩=XX|+⟩',
  'H|0⟩=ZZ|+⟩',
  'IX|0⟩=X|0⟩',
  'S|1⟩=SH|-⟩',
  'TT|0⟩=S|0⟩',
  'TST|0⟩=|0⟩',
  'H|+⟩=IZ|0⟩',
  'II|1⟩=X|0⟩',
  '|1⟩=IIH|-⟩',
  '|1⟩=SS-|1⟩',
  'YI|0⟩=Y|0⟩',
  'X|+⟩=ZZ|+⟩',
  'ST|0⟩=Z|0⟩',
  'S|+⟩=Z|i-⟩',
  'ZHZ|-⟩=|0⟩',
  'I|1⟩=XT|0⟩',
  '|+⟩=HTI|0⟩',
  'IS|0⟩=I|0⟩',
  '|0⟩=SXH|-⟩',
  'IS|1⟩=S|1⟩',
  '|0⟩=SSX|1⟩',
  'S|-⟩=SZ|+⟩',
  'IX|1⟩=Z|0⟩',
  'IYY|+⟩=|+⟩',
  '|+⟩=YYH|0⟩',
  'H|1⟩=SS|+⟩',
  'H|+⟩=ZI|0⟩',
  '|+⟩=ZII|-⟩',
  '|+⟩=IHH|+⟩',
  'YY|1⟩=X|0⟩',
  'Z|0⟩=IH|+⟩',
  'XXI|-⟩=|-⟩',
  'HTI|0⟩=|+⟩',
  'H|+⟩=TX|1⟩',
  'Y|+⟩=YI|+⟩',
  'S|+⟩=TT|+⟩',
  'IZ|0⟩=S|0⟩',
  'H|+⟩=HX|+⟩',
  'HI|1⟩=H|1⟩',
  '|+⟩=IXX|+⟩',
  'IY|0⟩=Y|0⟩',
  'ZZI|1⟩=|1⟩',
  'II|0⟩=H|+⟩',
  'XX|0⟩=S|0⟩',
  'ZTX|1⟩=|0⟩',
  'H|0⟩=XI|+⟩',
  'I|0⟩=HH|0⟩',
  'X|1⟩=II|0⟩',
  '|-⟩=HIX|0⟩',
  '|0⟩=XHI|-⟩',
  '|+⟩=HIH|+⟩',
  'SI|i+⟩=|-⟩',
  'SIS|-⟩=|+⟩',
  'HZH|+⟩=|+⟩',
  'XH|1⟩=X|-⟩',
  'SZ|i+⟩=|+⟩',
  'XXH|1⟩=|-⟩',
  'HX|1⟩=X|+⟩',
  'ZS|0⟩=X|1⟩',
  '|+⟩=ZIZ|+⟩',
  '-|-⟩=XH|1⟩',
  'I|0⟩=TZ|0⟩',
  'SIX|1⟩=|0⟩',
  'Y|-⟩=YZ|+⟩',
  '|0⟩=ISH|+⟩',
  'ZZ|0⟩=Z|0⟩',
  'Z|-⟩=IZ|-⟩',
  '-|1⟩=HX|-⟩',
  'HX|1⟩=Z|-⟩',
  'ZZ|0⟩=S|0⟩',
  'S|0⟩=XI|1⟩',
  'X|1⟩=XI|1⟩',
  'H|+⟩=XI|1⟩',
  'H|+⟩=ZZ|0⟩',
  'YZY|1⟩=|1⟩',
  'H|1⟩=ZI|+⟩',
  'XIH|0⟩=|+⟩',
  'SI|+⟩=|i+⟩',
  'ZT|0⟩=S|0⟩',
  'ST|0⟩=X|1⟩',
  '-|1⟩=SY|0⟩',
  'TX|1⟩=I|0⟩',
  'H|+⟩=HZ|-⟩',
  'XZZ|1⟩=|0⟩',
  'S|+⟩=IS|+⟩',
  'ZXZ|-⟩=|-⟩',
  'ZTH|+⟩=|0⟩',
  'IZI|-⟩=|+⟩',
  'TSH|+⟩=|0⟩',
  'IX|1⟩=T|0⟩',
  'YYX|+⟩=|+⟩',
  'ZTI|0⟩=|0⟩',
  'IIX|0⟩=|1⟩',
  'X|0⟩=HI|-⟩',
  '|1⟩=XSS|0⟩',
  'Z|1⟩=ZI|1⟩',
  '|1⟩=XTS|0⟩',
  '|1⟩=XTT|0⟩',
  '|0⟩=ZIH|+⟩',
  'HI|+⟩=S|0⟩',
  '|0⟩=HHS|0⟩',
  'Z-|-⟩=-|+⟩',
  'HH|1⟩=I|1⟩',
  'T|0⟩=YS|1⟩',
  'Z|-⟩=S|i-⟩',
  '|0⟩=THI|+⟩',
  '|0⟩=IXX|0⟩',
  '|+⟩=XHT|0⟩',
  'XZ|-⟩=H|0⟩',
  'ZHI|+⟩=|0⟩',
  '-|-⟩=Z-|+⟩',
  'H|1⟩=ZH|0⟩',
  'ZX|+⟩=I|-⟩',
  '|0⟩=YYX|1⟩',
  '|-⟩=ZSS|-⟩',
  'X|1⟩=IT|0⟩',
  'X|+⟩=ZH|1⟩',
  'H|0⟩=HX|1⟩',
  'HI|-⟩=I|1⟩',
  'HH|0⟩=I|0⟩',
  '|1⟩=XII|0⟩',
  'HHX|1⟩=|0⟩',
  '|+⟩=HTS|0⟩',
  'HIT|0⟩=|+⟩',
  'Z|0⟩=IT|0⟩',
  'YIY|1⟩=|1⟩',
  'S|i-⟩=X|+⟩',
  'YX|1⟩=S|1⟩',
  'ZXX|0⟩=|0⟩',
  '|0⟩=SSH|+⟩',
  '|-⟩=HXI|0⟩',
  '|-⟩=ZZZ|+⟩',
  'I|-⟩=IZ|+⟩',
  '|1⟩=YTY|1⟩',
  'X|0⟩=XH|+⟩',
  'HHX|0⟩=|1⟩',
  'TYS|1⟩=|0⟩',
  '|0⟩=SHI|+⟩',
  'IHI|+⟩=|0⟩',
  'S|-⟩=SH|1⟩',
  'HHI|0⟩=|0⟩',
  'Z|-⟩=HT|0⟩',
  'H|0⟩=SS|-⟩',
  'Z|0⟩=IZ|0⟩',
  'S|1⟩=IS|1⟩',
  'TT|1⟩=S|1⟩',
  'HX|1⟩=H|0⟩',
  'XH|0⟩=X|+⟩',
  'ZSS|+⟩=|+⟩',
  'I|0⟩=XX|0⟩',
  '|+⟩=HHH|0⟩',
  'YYZ|-⟩=|+⟩',
  '|1⟩=YYI|1⟩',
  'X|0⟩=XS|0⟩',
  'IHS|0⟩=|+⟩',
  'XX|1⟩=X|0⟩',
  'ITZ|0⟩=|0⟩',
  'ZZI|-⟩=|-⟩',
  'Z|0⟩=ZI|0⟩',
  'ST|0⟩=I|0⟩',
  'XT|0⟩=H|-⟩',
  '|1⟩=HHI|1⟩',
  '-|-⟩=HZ|1⟩',
  '|i+⟩=IS|+⟩',
  'X|1⟩=IS|0⟩',
  '|1⟩=XHH|0⟩',
  '|0⟩=ZXX|0⟩',
  'XS|i-⟩=|+⟩',
  '|0⟩=YIY|0⟩',
  'Y|1⟩=ZY|1⟩',
  '|1⟩=XZI|0⟩',
  'YT|0⟩=S|1⟩',
  'YY|1⟩=I|1⟩',
  '|+⟩=XHI|0⟩',
  '|+⟩=HYS|1⟩',
  'I|1⟩=HH|1⟩',
  'HII|1⟩=|-⟩',
  '|0⟩=TSH|+⟩',
  'X|0⟩=XZ|0⟩',
  'XH|1⟩=-|-⟩',
  'TT|0⟩=I|0⟩',
  'Z|0⟩=ZS|0⟩',
  '|0⟩=ISI|0⟩',
  '|1⟩=XIH|+⟩',
  '|1⟩=ZI-|1⟩',
  'XHT|0⟩=|+⟩',
  'XII|+⟩=|+⟩',
  '|i-⟩=ZS|+⟩',
  '|+⟩=HHI|+⟩',
  'YS|+⟩=S|+⟩',
  '|+⟩=XZI|-⟩',
  'H|+⟩=SH|+⟩',
  'IH|+⟩=X|1⟩',
  'Y|1⟩=TY|1⟩',
  '|0⟩=ZHH|0⟩',
  'S|0⟩=IH|+⟩',
  'SS|0⟩=S|0⟩',
  'XZ|-⟩=Z|-⟩',
  'Z|0⟩=XX|0⟩',
  'IHX|1⟩=|+⟩',
  'I|0⟩=SS|0⟩',
  '|0⟩=YYH|+⟩',
  '|0⟩=TTT|0⟩',
  'T|+⟩=IT|+⟩',
  'Z|+⟩=YY|-⟩',
  'IH|1⟩=H|1⟩',
  '|-⟩=TTS|+⟩',
  '-|1⟩=I-|1⟩',
  'XH|-⟩=X|1⟩',
  'XI|1⟩=I|0⟩',
  'ZXX|-⟩=|+⟩',
  '|0⟩=YYS|0⟩',
  'T|+⟩=TZ|-⟩',
  'TXX|0⟩=|0⟩',
  '|-⟩=HZ-|1⟩',
  'IST|0⟩=|0⟩',
  '|0⟩=ZZI|0⟩',
  '|+⟩=YYI|+⟩',
  '|0⟩=IZX|1⟩',
  '|0⟩=SIS|0⟩',
  'YI|1⟩=Y|1⟩',
  'ZSS|0⟩=|0⟩',
  'ZST|0⟩=|0⟩',
  'ZX|-⟩=-|+⟩',
  'H|-⟩=ZZ|1⟩',
  'X|1⟩=ZI|0⟩',
  'I|+⟩=HS|0⟩',
  '|1⟩=YYH|-⟩',
  'Z|+⟩=II|-⟩',
  'XYY|1⟩=|0⟩',
  'XI|+⟩=I|+⟩',
  '|0⟩=IIT|0⟩',
  'T|+⟩=TX|+⟩',
  '|1⟩=ZZX|0⟩',
  'SZS|1⟩=|1⟩',
  'SZS|0⟩=|0⟩',
  'TSZ|0⟩=|0⟩',
  'ZHX|1⟩=|-⟩',
  '-|-⟩=XZ|+⟩',
  'IZT|0⟩=|0⟩',
  '|+⟩=TST|-⟩',
  '|+⟩=HSX|1⟩',
  '|0⟩=ZSI|0⟩',
  'I|+⟩=ZH|1⟩',
  '|+⟩=XYY|+⟩',
  'HZ|1⟩=X|-⟩',
  '|-⟩=ZXZ|-⟩',
  'HZ|+⟩=I|1⟩',
  'XHI|0⟩=|+⟩',
  'ZXI|1⟩=|0⟩',
  'SS|+⟩=H|1⟩',
  '|1⟩=IXH|+⟩',
  'IXX|+⟩=|+⟩',
  'H|-⟩=XI|0⟩',
  'I|+⟩=HH|+⟩',
  'YS|0⟩=Y|0⟩',
  'XZ|0⟩=I|1⟩',
  'HXZ|0⟩=|-⟩',
  'SZ|0⟩=X|1⟩',
  'HZ|+⟩=X|0⟩',
  'ZT|0⟩=H|+⟩',
  'I|1⟩=HI|-⟩',
  'I|i+⟩=|i+⟩',
  'S|0⟩=TZ|0⟩',
  'IX|+⟩=Z|-⟩',
  '|0⟩=IYY|0⟩',
  '|1⟩=YIY|1⟩',
  'III|+⟩=|+⟩',
  'IX|-⟩=-|-⟩',
  'ZZI|+⟩=|+⟩',
  'II|0⟩=Z|0⟩',
  'ISH|+⟩=|0⟩',
  '|-⟩=ZXH|0⟩',
  'ZX|1⟩=I|0⟩',
  'YY|+⟩=H|0⟩',
  '|0⟩=HIZ|-⟩',
  'IHI|1⟩=|-⟩',
  'TI|0⟩=X|1⟩',
  '|-⟩=XH-|1⟩',
  '|+⟩=SIS|-⟩',
  '|i-⟩=SZ|+⟩',
  '|1⟩=IXI|0⟩',
  'HZH|0⟩=|1⟩',
  'H|1⟩=II|-⟩',
  'YYX|1⟩=|0⟩',
  'ZZ|+⟩=I|+⟩',
  'Y|0⟩=YZ|0⟩',
  'SI|-⟩=S|-⟩',
  'HX|1⟩=I|+⟩',
  'S|-⟩=SI|-⟩',
  'IS|-⟩=|i-⟩',
  'S|0⟩=YS|1⟩',
  'TT|-⟩=S|-⟩',
  'I|-⟩=YY|-⟩',
  'YYI|+⟩=|+⟩',
  'SI|0⟩=T|0⟩',
  'TTZ|0⟩=|0⟩',
  'HZX|1⟩=|+⟩',
  'HXH|-⟩=|+⟩',
  'YS|+⟩=|i+⟩',
  'HSX|1⟩=|+⟩',
  'ZZ|-⟩=I|-⟩',
  'X|-⟩=I-|-⟩',
  '|0⟩=HXZ|-⟩',
  'XXI|1⟩=|1⟩',
  'TS|0⟩=X|1⟩',
  'HXH|+⟩=|-⟩',
  '|+⟩=IXI|+⟩',
  'Z|-⟩=YY|+⟩',
  '|-⟩=HXX|1⟩',
  'IH|0⟩=H|0⟩',
  '|+⟩=ZZH|0⟩',
  'I|0⟩=ZZ|0⟩',
  'S|0⟩=SS|0⟩',
  '|0⟩=TIX|1⟩',
  '|1⟩=XST|0⟩',
  'TT|0⟩=H|+⟩',
  'SXI|1⟩=|0⟩',
  'XSS|-⟩=|+⟩',
  'HXX|-⟩=|1⟩',
  '|0⟩=THX|+⟩',
  'Y|0⟩=SX|0⟩',
  'YSY|1⟩=|1⟩',
  'I|+⟩=HZ|0⟩',
  'XI|-⟩=-|-⟩',
  'X|0⟩=XX|1⟩',
  'I|0⟩=TH|+⟩',
  '|+⟩=XIX|+⟩',
  'Y|i+⟩=S|+⟩',
  '|+⟩=HTT|0⟩',
  'IIZ|-⟩=|+⟩',
  'SI|0⟩=Z|0⟩',
  'Z|0⟩=SX|1⟩',
  'XX|+⟩=I|+⟩',
  '|0⟩=XXI|0⟩',
  'X|1⟩=ZS|0⟩',
  'H|+⟩=XH|-⟩',
  '|1⟩=IXT|0⟩',
  '|0⟩=ZSX|1⟩',
  'SX|0⟩=S|1⟩',
  'HXT|0⟩=|-⟩',
  '|0⟩=ZZS|0⟩',
  '|0⟩=HII|+⟩',
  'I|0⟩=XI|1⟩',
  '|-⟩=SSI|+⟩',
  'IH|0⟩=X|+⟩',
  'IHI|-⟩=|1⟩',
  'IH|+⟩=H|+⟩',
  'TH|+⟩=T|0⟩',
  '|0⟩=TXX|0⟩',
  '|-⟩=IYY|-⟩',
  'XI|0⟩=X|0⟩',
  'TT|i+⟩=|-⟩',
  'ISI|0⟩=|0⟩',
  'TTT|0⟩=|0⟩',
  'IX|+⟩=I|+⟩',
  '|0⟩=SII|0⟩',
  'HHZ|+⟩=|-⟩',
  'HTS|0⟩=|+⟩',
  'X|0⟩=XI|0⟩',
  '|1⟩=HSS|+⟩',
  'I|+⟩=SS|-⟩',
  'X|-⟩=IX|-⟩',
  'Y|1⟩=YX|0⟩',
  'TH|-⟩=T|1⟩',
  '|0⟩=IIS|0⟩',
  'HX|0⟩=Z|+⟩',
  'IYY|1⟩=|1⟩',
  '|+⟩=TT|i-⟩',
  'Y|1⟩=YH|-⟩',
  'YT|0⟩=Y|0⟩',
  'YY|0⟩=T|0⟩',
  'SSH|1⟩=|+⟩',
  'Y|0⟩=IS|1⟩',
  'TH|+⟩=H|+⟩',
  'SH|1⟩=|i-⟩',
  '|0⟩=ZTI|0⟩',
  '|1⟩=XSH|+⟩',
  'IH|+⟩=S|0⟩',
  'H|1⟩=HI|1⟩',
  'HZ|-⟩=S|0⟩',
  '|-⟩=HIH|-⟩',
  '|-⟩=HXZ|0⟩',
  'Z|0⟩=TZ|0⟩',
  'S|0⟩=ZS|0⟩',
  'X|+⟩=HT|0⟩',
  'T|0⟩=TH|+⟩',
  '|-⟩=IX-|-⟩',
  'XH|+⟩=I|1⟩',
  '|-⟩=XXH|1⟩',
  'X-|-⟩=Z|+⟩',
  'HHH|1⟩=|-⟩',
  'YX|+⟩=Y|+⟩',
  'H|-⟩=XS|0⟩',
  'X|0⟩=Z-|1⟩',
  'ZHX|-⟩=|1⟩',
  'XSH|+⟩=|1⟩',
  'HHI|+⟩=|+⟩',
  '|-⟩=SSX|+⟩',
  'ISS|0⟩=|0⟩',
  'HH|+⟩=X|+⟩',
  'XZI|0⟩=|1⟩',
  'TT|-⟩=|i-⟩',
  'ZZZ|0⟩=|0⟩',
  'S|1⟩=YS|0⟩',
  'XZI|-⟩=|+⟩',
  'HZ|0⟩=Z|-⟩',
  'H|1⟩=ZZ|-⟩',
  'YI|+⟩=Y|+⟩',
  '|0⟩=XXH|+⟩',
  'XZT|0⟩=|1⟩',
  'SI|0⟩=H|+⟩',
  'TSS|0⟩=|0⟩',
  '|0⟩=STX|1⟩',
  'T|0⟩=ST|0⟩',
  'ZS|i-⟩=|-⟩',
  'X|-⟩=XI|-⟩',
  '|-⟩=IZZ|-⟩',
  'ZX|1⟩=Z|0⟩',
  '|1⟩=ZX-|0⟩',
  'HH|-⟩=Z|+⟩',
  'IXI|+⟩=|+⟩',
  'HZ|-⟩=X|1⟩',
  '-|0⟩=XZ|1⟩',
  'HT|0⟩=I|+⟩',
  'ZIZ|+⟩=|+⟩',
  'IYS|1⟩=|0⟩',
  'YS|1⟩=Z|0⟩',
  'IHH|-⟩=|-⟩',
  'IS|0⟩=T|0⟩',
  '|0⟩=SZI|0⟩',
  'HYS|1⟩=|+⟩',
  'TX|1⟩=T|0⟩',
  '|0⟩=STH|+⟩',
  'IXH|-⟩=|0⟩',
  'T|0⟩=YY|0⟩',
  'ZI|-⟩=Z|-⟩',
  'H|+⟩=ZT|0⟩',
  '|0⟩=SZZ|0⟩',
  'XX|+⟩=Z|-⟩',
  '|-⟩=ZHX|1⟩',
  'I-|1⟩=Z|1⟩',
  'X|-⟩=HZ|1⟩',
  '|+⟩=HSS|0⟩',
  '|+⟩=SZ|i+⟩',
  '|1⟩=XIS|0⟩',
  'SH|-⟩=Y|0⟩',
  'I|i-⟩=|i-⟩',
  'X|1⟩=ZZ|0⟩',
  'IY|0⟩=S|1⟩',
  'Z|1⟩=HX|-⟩',
  'X|1⟩=TX|1⟩',
  'ZI|+⟩=I|-⟩',
  'HXX|0⟩=|+⟩',
  '|0⟩=ZZT|0⟩',
  'YYH|0⟩=|+⟩',
  'Z|0⟩=SI|0⟩',
  'IYY|-⟩=|-⟩',
  '|1⟩=ZSS|1⟩',
  'X|+⟩=IH|0⟩',
  '|0⟩=ZZH|+⟩',
  'T|0⟩=HX|+⟩',
  'ZH|1⟩=Z|-⟩',
  'XII|1⟩=|0⟩',
  'HZI|0⟩=|+⟩',
  '|0⟩=IXI|1⟩',
  'SSX|1⟩=|0⟩',
  'IH|0⟩=I|+⟩',
  'Y|1⟩=IY|1⟩',
  'IS|-⟩=S|-⟩',
  '|+⟩=ZZX|+⟩',
  'STX|1⟩=|0⟩',
  'IXT|0⟩=|1⟩',
  '|1⟩=YSY|1⟩',
  'SS|0⟩=T|0⟩',
  'IXX|0⟩=|0⟩',
  'HH|0⟩=Z|0⟩',
  'S|+⟩=ZS|-⟩',
  '|0⟩=ZYS|1⟩',
  'HIX|1⟩=|+⟩',
  '|0⟩=YSH|-⟩',
  '|0⟩=IHX|+⟩',
  'ZI|0⟩=T|0⟩',
  'SIT|0⟩=|0⟩',
  'XH|-⟩=T|0⟩',
  'TX|1⟩=S|0⟩',
  'SS|-⟩=H|0⟩',
  '|+⟩=ZIH|1⟩',
  '|0⟩=IIH|+⟩',
  '|0⟩=TSI|0⟩',
  'Z|+⟩=IH|1⟩',
  '|1⟩=SZS|1⟩',
  'TTH|+⟩=|0⟩',
  'XYY|0⟩=|1⟩',
  'S|0⟩=SI|0⟩',
  'XI|1⟩=T|0⟩',
  '|+⟩=IXH|0⟩',
  '|+⟩=HXI|1⟩',
  'IXH|0⟩=|+⟩',
  'XZZ|+⟩=|+⟩',
  'XX|+⟩=X|+⟩',
  '|0⟩=XHZ|+⟩',
  'XI|1⟩=Z|0⟩',
  'XXX|0⟩=|1⟩',
  '|0⟩=SSI|0⟩',
  'HIS|0⟩=|+⟩',
  'S|0⟩=SZ|0⟩',
  '|0⟩=XIH|-⟩',
  'XZH|+⟩=|1⟩',
  'H|+⟩=SZ|0⟩',
  '|+⟩=IHT|0⟩',
  'SS-|1⟩=|1⟩',
  '|0⟩=TST|0⟩',
  '|+⟩=HTH|+⟩',
  'HII|0⟩=|+⟩',
  '|0⟩=HZZ|+⟩',
  'ZI|0⟩=I|0⟩',
  'YI|0⟩=S|1⟩',
  'ZZH|-⟩=|1⟩',
  'T|0⟩=HH|0⟩',
  '|+⟩=ZSS|+⟩',
  '|+⟩=HSI|0⟩',
  '|+⟩=HHX|+⟩',
  'TH|+⟩=S|0⟩',
  'IZ-|1⟩=|1⟩',
  'H|1⟩=IH|1⟩',
  'T|-⟩=TZ|+⟩',
  'X-|-⟩=I|-⟩',
  'YX|1⟩=Y|0⟩',
  'HH|1⟩=X|0⟩',
  'I|+⟩=S|i-⟩',
  '|-⟩=HYY|1⟩',
  'SYY|0⟩=|0⟩',
  'YIY|0⟩=|0⟩',
  'ZIZ|1⟩=|1⟩',
  '|i+⟩=SH|0⟩',
  '|-⟩=ZHT|0⟩',
  'TI|-⟩=T|-⟩',
  'SS|0⟩=I|0⟩',
  'XXZ|-⟩=|+⟩',
  'S|0⟩=IX|1⟩',
  'Z|+⟩=IZ|+⟩',
  'S|0⟩=SH|+⟩',
  'I|0⟩=IX|1⟩',
  'H|+⟩=TT|0⟩',
  'ZH-|-⟩=|1⟩',
  'ZIZ|-⟩=|-⟩',
  'XH|-⟩=H|+⟩',
  '|+⟩=HIX|1⟩',
  'I|0⟩=II|0⟩',
  '|0⟩=HXH|0⟩',
  'XZ|+⟩=X|-⟩',
  'ZH|1⟩=I|+⟩',
  'X|1⟩=SS|0⟩',
  'I|1⟩=HZ|+⟩',
]

// TODO experiment with these:
export const WORDS2 = [
  'cos|0⟩+|+⟩',
  // 'cos|0⟩+eiφsin|+⟩',
]
